import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  getCartQuantity,
  getItems,
  getSubTotal,
  getTax,
  getTotal,
  increaseProductQnt,
  removeProduct,
  substructProductQnt,
  cartUpdated
} from '../../reducers/cartReducer'
import {getSvgIcon, productHasSizes} from '../../helpers/productHelper'
import CartItem2 from '../CartItem2'
import RaisedButton from 'material-ui/RaisedButton';
import {push} from 'connected-react-router'
import {ItemsIcon} from '../../icons';
import {ButtonWrapper, HeaderDiv, HeaderTitleDiv} from '../../pages';
import './cart.css'
import {isDelivery} from '../../selectors/address';
import { pushWithQueryParams } from '../../services/uri';


const styles = {
  button: { fontWeight: 700 },
  itemsIcon: { margin: '5px 0 0 0', padding: '0 2px 8px' },
  labelStyle: { fontWeight:700 },
  totalStyle: { fontWeight:700 },
  total: { fontWeight: 700 },
};

 class Cart extends Component {
  secondaryColor = ['#', this.props.secondaryColor].join('');

  handleQuantityUp = (productId) => {
    this.props.increaseProductQnt(productId);
  }
  handleQuantityDown = (productId) => {
    this.props.substructProductQnt(productId);
  }
  handleRemove = (productId) => {
    this.props.removeProduct(productId);
  }
  handleCheckoutClick = () => {
    const uri = [process.env.PUBLIC_URL, "/checkout"].join('');
    this.props.checkOutPage(uri);
  }
  render() {
    return (
      <div id="cart" className="treez-cart">
        <HeaderDiv>
          <HeaderTitleDiv>CART</HeaderTitleDiv>
        </HeaderDiv>
        <div className="cart-items-content">
          <div className="cart-items">
            { this.props.items.length === 0 && <div className="no-items">No items in your cart yet.</div> }
            { this.props.items.map((item, index) =>
              <CartItem2
                isWeight={productHasSizes(item.type)}
                color={this.props.secondaryColor}
                typeImgSrc={getSvgIcon(item.type)}
                edit={true}
                key={index}
                item={item}
                onQuantityUp={this.handleQuantityUp.bind(null, item.productId)}
                onQuantityDown={this.handleQuantityDown.bind(null, item.productId)}
                onRemove={this.handleRemove.bind(null, item.productId)}
              />) }
          </div>

          <div className="treezcart-items-details">
            <div><ItemsIcon style={styles.itemsIcon}/></div>
            <div className="treezcart-items-details-inner">
              <div className="treezcart-items-details-left">
                <div>Items Total: </div>
                <div>Subtotal: </div>
                <div>Tax: </div>
                <div style={styles.total}>Total:</div>
              </div>
              <div className="treezcart-items-details_right">
                <span>{this.props.totalQuantity}</span>
                <span>${this.props.subTotal}</span>
                <span>${this.props.tax}</span>
                <span style={styles.total}>${this.props.total}</span>
              </div>
            </div>
          </div>

          <ButtonWrapper>
            <RaisedButton
              onClick={this.handleCheckoutClick}
              backgroundColor={this.secondaryColor}
              labelColor="#FFF"
              label="Checkout"
              labelStyle={styles.labelStyle}
              style={styles.button}
              disabled={this.props.items.length === 0}
            />
         </ButtonWrapper>
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isDelivery: isDelivery(state),
    items : getItems(state),
    totalQuantity: getCartQuantity(state),
    subTotal: getSubTotal(state),
    tax: getTax(state),
    total: getTotal(state),
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    checkOutPage: (url) => dispatch(pushWithQueryParams(url)),
    increaseProductQnt: (productId) => {
      dispatch(increaseProductQnt(productId));
      dispatch(cartUpdated());
    },
    substructProductQnt: (productId) => {
      dispatch(substructProductQnt(productId));
      dispatch(cartUpdated());
    },
    removeProduct: (productId) => {
      dispatch(removeProduct(productId));
      dispatch(cartUpdated());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Cart);



// WEBPACK FOOTER //
// ./src/components/Cart/Cart.jsx